
import EntityServise from './entityService.js';

class JobStageService extends EntityServise {
    constructor() {
        super("jobStage")
    }

    async updateOrder(jobStageId, previousJobStageId, nextResourceId, nextJobStageId, noChangeOrder) {
        return await this.http.post(
            this.routeApi + "/update-status",
            {},
            { jobStageId, previousJobStageId, nextResourceId, nextJobStageId, noChangeOrder }
        );
    }

    async getAll(jobId, page, limit, search, searchFields) {
        if (search && search.length > 0 && searchFields && searchFields.length > 0) {
            return await this.search(jobId, searchFields, search, page, limit);
        }
        return await this.http.get(this.routeApi, { jobId, page, limit });
    }


    async getJobsInResourceByResourceId(resourceId) {

        return await this.http.get("jobstage/registry-jobs", { resourceId });

    }

    async getByJobCodeAndResource(codeJob, resourceId) {
        return await this.http.get("jobstage/s-job-resource", { codeJob, resourceId });

    }
}

export default new JobStageService();
